import React, { useRef, useState } from "react";
import styles from "./index.module.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useInvList } from "../../../hooks/react-query/inv-exchange/useInvList";
import FilterModelMobile from "./filter-model-mobile";
import FilterModel from "./filter-model";
import SearchMobile from "./search-model/search-mobile";
import SearchModel from "./search-model/search-model";
import { InvestorDashboardOpened } from "../../../utils/inv-exch-amplitude";

interface PropTypes {
  listView: boolean;
  setListView: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function FlipperVaultHeader({
  listView,
  setListView
}: PropTypes) {
  const [searchParams] = useSearchParams();
  const [showFilter, setShowFilter] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const { refetch } = useInvList();
  const navigate = useNavigate();
  const op: any = useRef(null);
  const searchRef: any = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const handleResize = () => {
    if (window.innerWidth <= 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  React.useEffect(() => {
    setIsMobile(window.innerWidth <= 768 ? true : false);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className={styles.header}>
      <div className={styles.left}>
        <img
          className={styles.tag}
          src="/images/back.svg"
          alt=""
          onClick={() => {
            if (showFilter) {
              sessionStorage.removeItem('flipper-vault-horizontal-scroll-position')
              setShowFilter(false);
            } else {
              sessionStorage.removeItem('flipper-vault-horizontal-scroll-position')
              navigate(
                "/properties?lat=32.579632406829035&lng=-116.8282973867345&zoom=6.321072704923566&state=CA&status=Active"
              );
            }
          }}
        />
        <div className={styles.addressMobile}>
          <div className={styles.addressText}>{searchParams.get("street")}</div>
          <div className={styles.addressSubText}>
            {searchParams.get("city")}, {searchParams.get("state")}{" "}
            {searchParams.get("postalCode")}
          </div>
        </div>
        <div className={styles.address}>
          {searchParams.get("street")}, {searchParams.get("city")},{" "}
          {searchParams.get("state")} {searchParams.get("postalCode")}
        </div>
      </div>
      <div className={styles.right}>
        <img
          width={20}
          src="/images/search-dark.svg"
          alt=""
          onClick={(e) => {
            if (isMobile) {
              setShowSearch(!showSearch);
              setShowFilter(false);
              return;
            } else if (searchRef?.current) {
              searchRef?.current.toggle(e);
            }
          }}
        />
        <SearchMobile showSearch={showSearch} setShowSearch={setShowSearch} />
        <SearchModel searchRef={searchRef} />
        <img
          width={20}
          src="/images/filter1.svg"
          alt=""
          onClick={(e) => {
            if (isMobile) {
              setShowFilter(!showFilter);
              setShowSearch(false);
              return;
            } else if (op?.current) {
              op?.current.toggle(e);
            }
          }}
        />
        <FilterModelMobile
          showFilter={showFilter}
          setShowFilter={setShowFilter}
        />
        <FilterModel popRef={op} />
        <img
          width={20}
          src="/images/investor-active.svg"
          alt="map"
          onClick={() => {
            InvestorDashboardOpened({
              property_id: searchParams.get("pid") || "",
              property_sfid: searchParams.get("sfid") || ""
            });
            navigate(
              `/inv-list?street=${encodeURIComponent(
                searchParams.get("street") || ""
              )}&city=${encodeURIComponent(
                searchParams.get("city") || ""
              )}&postalCode=${encodeURIComponent(
                searchParams.get("postalCode") || ""
              )}`
            );
            refetch();
          }}
        />
      </div>
    </div>
  );
}
